module.exports = __webpack_public_path__ + "assets/img/1.9d9a0519.png";